module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/inner-7-d56e936485ded3f86d909d070a1e4b56.jpg";